import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarMonthRegular = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 12C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11C15 11.5523 15.4477 12 16 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 18C16.5523 18 17 17.5523 17 17C17 16.4477 16.5523 16 16 16C15.4477 16 15 16.4477 15 17C15 17.5523 15.4477 18 16 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 24C16.5523 24 17 23.5522 17 23C17 22.4477 16.5523 22 16 22C15.4477 22 15 22.4477 15 23C15 23.5522 15.4477 24 16 24Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99998 12C10.5523 12 11 11.5523 11 11C11 10.4477 10.5523 10 9.99998 10C9.4477 10 8.99998 10.4477 8.99998 11C8.99998 11.5523 9.4477 12 9.99998 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 5.24947H22.75V3.00047C22.75 2.80156 22.671 2.61079 22.5303 2.47014C22.3897 2.32949 22.1989 2.25047 22 2.25047C21.8011 2.25047 21.6103 2.32949 21.4697 2.47014C21.329 2.61079 21.25 2.80156 21.25 3.00047V5.24947H10.75V3.00047C10.75 2.80156 10.671 2.61079 10.5303 2.47014C10.3897 2.32949 10.1989 2.25047 10 2.25047C9.80109 2.25047 9.61032 2.32949 9.46967 2.47014C9.32902 2.61079 9.25 2.80156 9.25 3.00047V5.24947H9C7.74066 5.2509 6.53331 5.7518 5.64282 6.64229C4.75233 7.53278 4.25143 8.74013 4.25 9.99947V23.9995C4.25143 25.2588 4.75233 26.4662 5.64282 27.3566C6.53331 28.2471 7.74066 28.748 9 28.7495H23C24.2593 28.748 25.4667 28.2471 26.3572 27.3566C27.2477 26.4662 27.7486 25.2588 27.75 23.9995V9.99947C27.7486 8.74013 27.2477 7.53278 26.3572 6.64229C25.4667 5.7518 24.2593 5.2509 23 5.24947ZM26.25 23.9995C26.249 24.8611 25.9063 25.6872 25.297 26.2965C24.6877 26.9057 23.8616 27.2485 23 27.2495H9C8.13835 27.2485 7.31228 26.9057 6.703 26.2965C6.09372 25.6872 5.751 24.8611 5.75 23.9995V9.99947C5.751 9.13782 6.09373 8.31175 6.703 7.70247C7.31228 7.0932 8.13835 6.75047 9 6.74947H23C23.8616 6.75046 24.6877 7.09319 25.297 7.70247C25.9063 8.31175 26.249 9.13782 26.25 9.99947V23.9995Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99998 18C10.5523 18 11 17.5523 11 17C11 16.4477 10.5523 16 9.99998 16C9.4477 16 8.99998 16.4477 8.99998 17C8.99998 17.5523 9.4477 18 9.99998 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99998 24C10.5523 24 11 23.5522 11 23C11 22.4477 10.5523 22 9.99998 22C9.4477 22 8.99998 22.4477 8.99998 23C8.99998 23.5522 9.4477 24 9.99998 24Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 12C22.5523 12 23 11.5523 23 11C23 10.4477 22.5523 10 22 10C21.4477 10 21 10.4477 21 11C21 11.5523 21.4477 12 22 12Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 18C22.5523 18 23 17.5523 23 17C23 16.4477 22.5523 16 22 16C21.4477 16 21 16.4477 21 17C21 17.5523 21.4477 18 22 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 24C22.5523 24 23 23.5522 23 23C23 22.4477 22.5523 22 22 22C21.4477 22 21 22.4477 21 23C21 23.5522 21.4477 24 22 24Z",
			fill: "currentColor"
		})
	]
});
export default SvgCalendarMonthRegular;
